export enum SalesManagoTag {
    HOME_PAGE = 'HOME_PAGE',
}
